<template>
  <v-container
    class="fill-height px-4 pb-4"
    fluid
  >
      <v-row
      no-gutters
      justify="center"
      dense
      class="mx-4 mt-0 mb-4"
    >
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">Upload Asset Images</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2">Asset Images</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card
                class="mb-12"
                flat
              >
                <v-card-title>
                  <span class="headline">Upload Asset Images</span>
                </v-card-title>
                
                <v-container> 
                  <v-form
                    ref="form"
                    lazy-validation
                  >      
                    <p>What would you like to do?</p>
                    <v-radio-group v-model="task" :mandatory="true" :rules="inputRules" hide-details>
                      <v-radio label="Add / Update existing assets with resources" value="update-existing"></v-radio>
                    </v-radio-group>
                    <v-row no-gutters v-if="autoCropTokens != -1" align="end">
                      <v-col cols="auto">
                        <v-switch style="width;50px;" dense v-model="autoCropEnabled" hide-details label="Autocrop uploaded images"></v-switch>
                      </v-col>
                      <v-col cols="auto">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon class="ml-2" size="19px" color="primary" v-on="on">mdi-information</v-icon>
                          </template>
                          <span>If enabled, uploaded assets that are JPG / PNG file types will have their backgrounds removed and empty space cropped. This will cost one token per image.</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12">
                        <b>{{autoCropTokens}} </b> Tokens left
                      </v-col>
                    </v-row>

                    <v-container v-if="task == 'update-existing'" >
                      <v-row no-gutters align="end">
                        <v-col cols="auto">
                           <v-switch hide-details dense v-model="createNewIfNotFound" label="Create new asset if identifier is not found?"></v-switch>
                        </v-col>
                        <v-col>
                           <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon class="ml-2" size="19px" color="primary" v-on="on">mdi-information</v-icon>
                          </template>
                          <span>If there are resources with names that do not match an existing asset then a new asset will be created.</span>
                        </v-tooltip>
                        </v-col>
                      </v-row>
                      <v-row no-gutters align="end">
                        <v-col cols="auto">
                          <v-switch dense v-model="replaceExistingResource" hide-details label="Replace existing asset resources?"></v-switch>
                        </v-col>
                        <v-col>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon class="ml-2" size="19px" color="primary" v-on="on">mdi-information</v-icon>
                            </template>
                            <span>Using this option will either add or replace a resource if a similar filename already exists.</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>

                      <v-row no-gutters align="end">
                        <v-col cols="auto">
                          <v-switch dense v-model="removeExistingResourcesOfTheSameType" hide-details label="Remove existing resources of the same type?"></v-switch>
                        </v-col>
                        <v-col>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon class="ml-2" size="19px" color="primary" v-on="on">mdi-information</v-icon>
                            </template>
                            <span>Using this option will remove existing resources from matched assets of the same type (e.g. images / 3D models) before adding the new resource.</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>

                      <v-row no-gutters align="end">
                        <v-col cols="auto">
                          <v-switch dense v-model="addOnlyIfNoExistingType" hide-details label="Only add if no existing resource of same type found?"></v-switch>
                        </v-col>
                        <v-col>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon class="ml-2" size="19px" color="primary" v-on="on">mdi-information</v-icon>
                            </template>
                            <span>Using this option will only add the resource if an existing one of the same type does not exist on the asset.</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>

                        <v-row no-gutters align="end">
                        <v-col cols="auto">
                          <v-switch dense v-model="seperateUnderscoresIntoTags" hide-details label="Seperate underscores into tags"></v-switch>
                        </v-col>
                        <v-col>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon class="ml-2" size="19px" color="primary" v-on="on">mdi-information</v-icon>
                            </template>
                            <span>Using this option will cause underscores after the first word to be added as tags to the resource and to search for an asset without these tags.</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>


                      <v-row no-gutters align="end">
                        <v-col cols="auto">
                          <v-switch dense v-model="targetSpecificCategory" hide-details label="Target specific category?"></v-switch>
                        </v-col>
                        <v-col>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon class="ml-2" size="19px" color="primary" v-on="on">mdi-information</v-icon>
                            </template>
                            <span>Using this option will mean that only assets within the specified section / category will be checked against.</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>


                    </v-container>

                    <v-select
                      v-if="task == 'add-new' || (task == 'update-existing' && createNewIfNotFound || targetSpecificCategory)"
                      :items="sectionHeaders"
                      :menu-props="{ maxHeight: '400' }"
                      v-model="selectedSection"
                      item-text="name"
                      item-value="id"
                      label="Which Section should the Asset(s) be in?"
                      :rules="newAssetRules"
                      required
                    ></v-select>
                    
                    <v-select
                      :items="categoryHeaders"
                      :menu-props="{ maxHeight: '400' }"
                      v-if="(task == 'add-new' || (task == 'update-existing' && createNewIfNotFound || targetSpecificCategory)) && (section !== null || this.selectedSection !== null) "
                      v-model="selectedCategory" 
                      item-text="name"
                      item-value="id"
                      label="Which Category should the Asset(s) be in?"
                      :rules="newAssetRules"
                      required
                    ></v-select>
                  </v-form>
                </v-container>
              </v-card>

              <v-row justify="center" class="mb-6">
                <v-btn
                  color="primary"
                  class="mr-4"
                  @click="validate()"
                >
                    Continue
                </v-btn>
              </v-row>
            </v-stepper-content>
            <v-stepper-content step="2" style="min-width:800px;">
              <v-card 
                class="mb-12"
                flat
              >
                  <v-card-title>
                      <span class="headline">Asset Images</span>
                  </v-card-title>

                  <v-container >
                    <v-row class="cardcontent" v-if="!uploadComplete">
                        <v-col cols="12" class="" >
                            <v-card
                                class="upload"
                                color="transparent"
                                min-height="200px"
                                flat
                            >
                                <v-simple-table v-if="this.files.length" height="400px" fixed-header>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th >Thumb</th>
                                                <th class="text-left">File Name</th>
                                                <th >Status</th>
                                                <!--<th >Progress</th>-->
                                                <th >Size</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(file,index) in files" :key="file.id">
                                                <td> 
                                                  <v-img class="td-image-thumb" v-if="file.thumb" :src="file.thumb" height="40px" width="40px" contain />
                                                  <span v-else>No Image</span>
                                                </td>
                                                <td>{{ file.name }}</td>
                                                <td v-if="file.error">{{file.error}}</td>
                                                <td v-else-if="file.success">Success</td>
                                                <td v-else-if="file.active">Uploading</td>
                                                <td v-else></td>
                                                <!--<td><v-progress-linear background-color="error" color="success" :value= "file.progress"></v-progress-linear></td>-->
                                                <td>{{ file.size }}</td>
                                                <td>
                                                    <v-btn class="icon-btn" color="red" icon @click="files.splice(index,1)">
                                                        <v-icon>mdi-file-remove</v-icon>
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                
                                <v-container 
                                    class="fill-height pa-4"
                                    fluid
                                > 
                                    <v-row justify="center" align="center">
                                        <v-btn max-width="220px" v-if="!updatingAssets && !priorUploadsCompleted">
                                            <label for="file" class="btn btn-lg btn-primary" style="" >
                                                Drop or Select Files
                                            </label>
                                        </v-btn>
                                    </v-row>
                                </v-container>
                            </v-card>
                        </v-col>
                    </v-row>
                    <template v-else-if="this.imageUploadOutput.errorList != null && this.imageUploadOutput.errorList.length">
                      <v-row class="ma-2 pa-2 cardcontent">
                          Image upload complete with the following errors:
                      </v-row>
                      <v-row class="ma-2 pa-2 cardContent" justify="center"> 
                        <v-simple-table id="files2-table" v-if="this.imageUploadOutput.errorList != null && this.imageUploadOutput.errorList.length">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                      <th class="text-left">Asset Detail Id</th>
                                      <th class="text-left">File Name</th>
                                      <th class="text-left">Output</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item) in imageUploadOutput.errorList" :key="item">
                                        <td>{{ item.assetDetailid }}</td>
                                        <td>{{ item.fileName }}</td>
                                        <td>{{ item.output }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>   
                      </v-row>
                    </template>
                    <v-row v-else class="ma-2 pa-2 cardContent">
                        Image upload successful.
                    </v-row>

                    <v-row v-if="priorUploadsCompleted">
                      <v-col>
                        Image upload completed
                      </v-col>
                    </v-row>

                    <!--
                    <JobProgress ref="uploadProgress" v-if="(this.assetsInCreation || this.updatingAssets) && !this.uploadComplete" :importJobId="this.importJobId"></JobProgress>
                    -->
                  </v-container>
                  
                  <v-card-actions>
                      <v-row justify="center" style="margin: 0px">
                        <v-btn 
                          color="blue-grey lighten-5" 
                          @click="e1 = e1 - 1"
                          :disabled="this.assetsInCreation"
                        >
                          Back
                        </v-btn>
                        <v-btn 
                          v-if="uploadComplete"
                          color="blue-grey lighten-5" 
                          @click="selectedSection !== null ? viewAssets(selectedSection) : viewAssets(sectionHeaders[0])"
                        >
                          Finish
                        </v-btn>
                        <v-btn
                          v-else-if="task == 'add-new'"
                          color="primary"
                          class="mr-4"
                          :disabled="this.files.length == 0 || this.assetsInCreation"
                          @click="createAssets()"
                        >
                            <v-icon 
                                v-if="this.assetsInCreation" 
                                size="28" 
                                color="white" dark
                            >
                                mdi-loading mdi-spin
                            </v-icon>
                            <span v-else>Create Assets</span>
                        </v-btn>
                        <v-btn
                          v-else-if="task == 'update-existing' && priorUploadsCompleted"
                          color="primary"
                          class="mr-4"
                          @click="ClearFiles()"
                        >
                              <span>Start New Upload</span>
                        </v-btn>
                        <v-btn
                          v-else
                          color="primary"
                          class="mr-4"
                          :disabled="(this.files.length == 0 || this.updatingAssets) && !finishedUpload"
                          @click="StartIncrementalUpload()"
                        >
                              <v-icon 
                                  v-if="this.updatingAssets && !finishedUpload" 
                                  size="28" 
                                  color="white" dark
                              >
                                  mdi-loading mdi-spin
                              </v-icon>
                              <span v-else>Begin Upload</span>
                        </v-btn>
                    </v-row>
                  </v-card-actions>
                  <file-upload
                      :data="formObject"
                      :multiple="true"
                      :drop="true"
                      :drop-directory="true"
                      :post-action="postEndPoint"
                      :maximum="50000"
                      accept="image/*"
                      @input-filter="inputFilter"
                      v-model="files"
                      ref="upload"
                      :headers="GetAuthHeaderObj"
                      :custom-action="customAction"
                  ></file-upload>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
    </v-row>
  </v-container>
</template>


<script>
import CONFIG from '../../../appconfig.json'
import { mapState, mapActions, mapGetters } from 'vuex'

import FileUpload from 'vue-upload-component'
import AttributeField from '../../attributes/AttributeField'
import AttributeSearch from '../../attributes/AttributeSearch'
import JobProgress from '../../shared/JobProgress'
import axios from 'axios'
import { GetAuthorisationHeaderGroup} from '@/vuex/assetxphelpers'

export default {
  name: 'AssetImageImport',
  components: {
    FileUpload,
    AttributeField,
    AttributeSearch,
    JobProgress
  },
  props: {

  },
  computed:{
    ...mapState("assetxpstate", [
        "sectionHeaders",
        "categoryHeaders",
        "section"
    ]),

    ...mapGetters("authentication", [
        "GetAuthHeaderObj"
      ]),

    postEndPoint() {
        return CONFIG.platformEndpoints.assetxpapi + "section/uploadFileIncremental";
    },

    finishedUpload() {

      if(this.$refs.upload != null)
      {
        if(!this.$refs.upload.active && this.updatingAssets)
        {
          this.updatingAssets = false;
          this.priorUploadsCompleted = true;
        }

        return !this.$refs.upload.active;
      }
      else
      {
        return false;
      }
    }
  },
  mounted:  function () {
    this.GetAutoCropTokens();
    this.GetSectionHeaders();
    this.selectedSection = this.section !== null ? this.section.id : null;
    if(this.section !== null) {
      this.GetSectionAttributes(this.section.id)
        .then((response) => {
          this.attributes = response.data;
        })
    }
  },
  data(){ 
    return {
      autoCropTokens : -1,
      autoCropEnabled : false,
      formObject : null,
      e1: 1,
      importJobId: null,
      assetsInCreation: false,
      newAssetIds: [],
      uploadComplete: false,
      imageUploadOutput: {},
      files: [],
      file : {},
      updatingAssets: false,
      selectedSection: null, 
      selectedCategory: null,
      sectionAttributes: [],
      attributes: [],
      attributeValues: [],
      task: 'update-existing',
      replaceExistingResource: false,
      createNewIfNotFound: false,
      targetSpecificCategory: false,
      removeExistingResourcesOfTheSameType: false,
      addOnlyIfNoExistingType : false,
      seperateUnderscoresIntoTags : true,
      inputRules: [
        v => v !== null || 'This is a required field.',
        v => v !== '' || 'This is a required field.'
      ],
      newAssetRules: [
        v => (this.task == 'add-new' || (this.task == 'update-existing' && this.createNewIfNotFound || this.targetSpecificCategory)) && v !== null || 'This is a required field.',
        v => (this.task == 'add-new' || (this.task == 'update-existing' && this.createNewIfNotFound || this.targetSpecificCategory)) && v !== '' || 'This is a required field.'

      ],
      priorUploadsCompleted : false
    }
  },
  methods:{
    
    ...mapActions("assetxpstate", [
        "GetSectionHeaders",
        "GetCategoryHeadersBySection",
        "ImportAssetsFromImages",
        "GetSearchResults",
        "GetSectionById",
        "GetSectionAttributes",
        "UpdateAssetsFromImages",
        "UpdateAssetsWithImages",
        "StartNewJob",
        "UploadResourceIndividual"
    ]),

    GetAutoCropTokens()
    {
        this.autoCropTokens = -1;
        axios.get(CONFIG.platformEndpoints.assetxpapi +  'axpsettings/GetAutoCropAllowance',GetAuthorisationHeaderGroup())
        .then( (response) => {
            this.autoCropTokens = response.data;
        })
    },

    async customAction(file, component) {
        
        return await this.UploadResourceIndividual({autoCropEnabled : this.autoCropEnabled,file : file, replaceResources : this.replaceExistingResource, createNewAssetIfNotFound : this.createNewIfNotFound, targetSpecificCategory : this.targetSpecificCategory, removeExistingResourcesOfTheSameType : this.removeExistingResourcesOfTheSameType, seperateUnderscoresIntoTags : this.seperateUnderscoresIntoTags ,  addOnlyIfNoExistingType : this.addOnlyIfNoExistingType,sectionid : this.selectedSection, categoryid : this.selectedCategory});

    },
    ClearFiles()
    {
      this.files = [];
      this.priorUploadsCompleted = false;
      this.updatingAssets = false; 
      this.$refs.upload.active = false;
    },
    StartIncrementalUpload()
    {
      this.updatingAssets = true; 
      
       //Starts the incremental upload process
      this.$refs.upload.active = true;
      this.priorUploadsCompleted = false;
    },
    validate(){
      if(this.$refs.form.validate()) {
        this.e1 = this.e1 + 1;
      }
    },
    getCategoryHeaders() {
      if(this.section !== null || this.selectedSection !== null) {
        this.category = null;
        this.GetCategoryHeadersBySection(this.selectedSection);
      }
    },
    inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
            // Before adding a file
            // Filter system files or hide files
            if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                return prevent()
            }

            // Filter php html js file
            if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                return prevent()
            }
        }

        if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }

            // Thumbnails
            newFile.thumb = ''
            
            if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                newFile.thumb = newFile.blob
            }
        }
    },
    async createAssets () {
      this.assetsInCreation = true; 

       /*
      var newJob = {
        name: "Update Asset Images",
        totalCount: this.$refs.upload.files.length,
        jobType: this.task == 'add-new' ? 2 : this.replaceExistingResource ? 4 : 3,
        status: 0
      };

     
      await this.StartNewJob(newJob).then((response) =>{
        this.importJobId = response.data.id;
        this.$refs.uploadProgress.setJobId({ jobId: this.importJobId, intv: 1000 });
      });
      */
      
      let formData = new window.FormData();
      formData.set('jobid', this.importJobId);
      formData.set('sectionid', this.selectedSection);
      formData.set('categoryid', this.selectedCategory);
      formData.set('autoCropEnabled', this.autoCropEnabled);

      for (var i = 0; i < this.$refs.upload.files.length; i++) {
        var file = this.$refs.upload.files[i];
        let value

        for (let key in file.data) {
          value = file.data[key]
          if (value && typeof value === 'object' && typeof value.toString !== 'function') {
            if (value instanceof File) {
              formData.append(key, value, value.name)
            } else {
              formData.append(key, JSON.stringify(value))
            }
          } else if (value !== null && value !== undefined) {
            formData.append(key, value)
          }
        }

        formData.append(this.name, file.file, file.file.filename || file.name)
      }

      this.ImportAssetsFromImages(formData)
        .then((response) => {
          this.uploadComplete = true;
        })  
    },
    async updateAssetImages () {
      this.updatingAssets = true; 

      let formData = new window.FormData();
      formData.set('jobid', this.importJobId);
      formData.set('replaceResources', this.replaceExistingResource);
      formData.set('createNewAssetIfNotFound', this.createNewIfNotFound);
      formData.set('addOnlyIfNoExistingType', this.addOnlyIfNoExistingType);

      if(this.createNewIfNotFound)
      {
        formData.set('sectionid', this.selectedSection);
        formData.set('categoryid', this.selectedCategory);
      }

      for (var i = 0; i < this.$refs.upload.files.length; i++) {
        var file = this.$refs.upload.files[i];
        let value

        for (let key in file.data) {
          value = file.data[key]
          if (value && typeof value === 'object' && typeof value.toString !== 'function') {
            if (value instanceof File) {
              formData.append(key, value, value.name)
            } else {
              formData.append(key, JSON.stringify(value))
            }
          } else if (value !== null && value !== undefined) {
            formData.append(key, value)
          }
        }

        formData.append(this.name, file.file, file.file.filename || file.name)
      }

      this.UpdateAssetsWithImages(formData)
        .then((response) => {
          this.uploadComplete = true;
          this.uploadingImages = false;
          this.imageUploadOutput = response.data;
        })  
    },
    viewAssets(sectionid) {
        this.GetSectionById(sectionid).then((response) => {
          this.$router.push({ name: 'Section Search', params: { sectionName: this.section.name }});
        })
    },
  },
  watch: {
    files () {

      console.log("Files changed",this.$data.files);

      if (this.$data.files.length > 0 && this.updatingAssets)
      {
        if (this.$data.files.every(file => !file.active))
        {
          this.priorUploadsCompleted = true;
        }
      }
    },
    selectedSection() {
        this.category = null;
        this.GetCategoryHeadersBySection(this.selectedSection);
        this.GetSectionAttributes(this.selectedSection)
          .then((response) => {
            this.attributes = response.data;
          }) 
    },
    e1 () {

      this.formObject = {};

      this.$set(this.formObject, 'replaceResources', this.replaceExistingResource);
      this.$set(this.formObject, 'createNewAssetIfNotFound', this.createNewIfNotFound);
      this.$set(this.formObject,'addOnlyIfNoExistingType', this.addOnlyIfNoExistingType);

      if(this.createNewIfNotFound)
      {
        this.$set(this.formObject, 'sectionid', this.selectedSection);
        this.$set(this.formObject, 'categoryid', this.selectedCategory);
      }

    }
  }
}
</script> 

<style>

</style>